module.exports = __webpack_public_path__ + "img/logo.84d72145.svg";